import React from 'react';
import {
   PageHeader,
   PageTitle,
   SettingsTab,
   Wrapper,
   useVendoData,
} from '@/pages/Admin/Vendo';

const WifiSettings = () => {
   useVendoData({ sessions: false });
   return (
      <Wrapper>
         <PageHeader>
            <PageTitle>Settings</PageTitle>
         </PageHeader>
         <SettingsTab />
      </Wrapper>
   );
};

export default WifiSettings;
